import { Mail, MapPin, Clock, Phone } from "lucide-react";
import { COMPANY, NAV } from "@/constants/company";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-forest-900 text-sage-50 pt-14 md:pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10 md:gap-10 pb-12 md:pb-16">
          <div className="col-span-2 md:col-span-1">
            <div className="rounded-xl bg-sage-50 inline-block px-4 py-3">
              <img
                src={COMPANY.logo}
                alt="Rossi Energia"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="mt-4 font-serif italic text-lg text-sage-200">
              «Non aver paura di accendere la tua vita.»
            </p>
            <p className="mt-3 text-sm font-light text-sage-200/70 leading-relaxed max-w-xs">
              Consulenza per forniture luce e gas, per privati e business.
              Offerte su misura, costi chiari, assistenza continua.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-sage-300 mb-4">
              Naviga
            </h4>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <button
                    onClick={() => scrollTo(n.href)}
                    className="inline-block text-sm text-sage-100 hover:text-white transition-[color,transform] duration-300 ease-out hover:translate-x-0.5"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
              <li>
                <a
                  href="/privacy/"
                  className="inline-block text-sm text-sage-100 hover:text-white transition-[color,transform] duration-300 ease-out hover:translate-x-0.5"
                >
                  Privacy
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-sage-300 mb-4">
              Contatti
            </h4>
            <ul className="space-y-4 text-sm text-sage-100">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 text-sage-300 mt-0.5" strokeWidth={1.7} />
                <a href={COMPANY.phoneTel} className="hover:text-white transition-colors duration-300">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 text-sage-300 mt-0.5" strokeWidth={1.7} />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white transition-colors duration-300">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-sage-300 mt-0.5" strokeWidth={1.7} />
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-4 w-4 text-sage-300 mt-0.5" strokeWidth={1.7} />
                <span>{COMPANY.orari}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-sage-300 mb-4">
              Azienda
            </h4>
            <ul className="space-y-3 text-sm text-sage-100">
              <li>{COMPANY.legal}</li>
              <li>P.IVA {COMPANY.piva}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-sage-50/10 pt-8">
          <div className="font-serif text-[15vw] leading-none text-sage-50/[0.06] select-none pointer-events-none tracking-tight">
            Rossi Energia
          </div>
          <p className="mt-6 text-xs text-sage-200/50">
            © {new Date().getFullYear()} {COMPANY.legal} · P.IVA {COMPANY.piva}. Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
}
